import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { useTranslation } from 'react-i18next';

import GenericHalfModal from '@Components/common/generic-half-modal';

import { useModal } from '@app/components/modal-views/context';
import { useLazyGetStatusQuery, useLogoutMutation } from '@app/store/auth/api';
import { initialAuthState, setAuth } from '@app/store/auth/slice';
import { useAppDispatch } from '@app/store/hooks';
import { resetAfterSignOut } from '@app/store/actions/reset-after-sign-out';

export default function LogoutView(props: any) {
    const { t } = useTranslation();
    const { closeModal } = useModal();
    const [trigger] = useLogoutMutation();
    const [authTrigger] = useLazyGetStatusQuery();
    const dispatch = useAppDispatch();

    const workspace = props?.workspace;

    const router = useRouter();
    const pathname = usePathname();
    const searchParams = useSearchParams();

    const asPath = `${pathname}${searchParams?.toString() ? '?' + searchParams.toString() : ''}`;

    const handleLogout = async () => {
        await trigger().then(async () => {
            await authTrigger();
            if (!props?.skipRedirect) {
                if (!!workspace && !!workspace?.workspaceName && props?.isClientDomain) router.push(asPath);
                else router.push('/login');
            }
            dispatch(setAuth(initialAuthState));
            // the next person at this browser must not see what this user saw
            resetAfterSignOut(dispatch);
            closeModal();
        });
    };

    return <GenericHalfModal headerTitle={t('STAFF.LOGOUT.HEADER')} title={t('STAFF.LOGOUT.TITLE')} type="danger" positiveText={t('BUTTON.YES')} negativeText={t('BUTTON.NO')} positiveAction={handleLogout} />;
}
